package it.neckar.lizergy.model.location

import it.neckar.rest.RestRequest
import kotlinx.serialization.Serializable

@Serializable
data class GeocodingRequest(val address: it.neckar.lizergy.model.customer.Address) : RestRequest
